<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title class="mt-3">
      Promo codes
      <v-spacer />
      <v-btn @click="rowClick({})"> Add </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :items-per-page="-1"
        disable-pagination
        class="row-pointer"
        mobile-breakpoint="0"
        @click:row="rowClick"
      >
        <template #[`item.productTypeId`]="{ item }">
          {{ product_type_name(item.productTypeId) }}
        </template>
        <template #[`item.value`]="{ item }">
          <template v-if="item.isPercentageDiscount"> {{ item.value }}% </template>
          <template v-else> ${{ item.value }} </template>
        </template>
        <template #[`item.minimumProductValue`]="{ item }">
          ${{ item.minimumProductValue }}
        </template>
        <template #[`item.startDate`]="{ item }">
          {{ item.startDate | normalDate }}
        </template>
        <template #[`item.endDate`]="{ item }">
          {{ item.endDate | normalDate }}
        </template>
        <template #[`item.multipleUse`]="{ item }">
          <v-icon
            v-if="item.multipleUse"
            color="success"
          >
            check_circle
          </v-icon>
        </template>
        <template #[`item.firstPrintOnly`]="{ item }">
          <v-icon
            v-if="item.firstPrintOnly"
            color="success"
          >
            check_circle
          </v-icon>
        </template>
        <template #[`item.masterAccountId`]="{ item }">
          <template v-if="item.masterAccountId">
            {{ master_account_name(item.masterAccountId) || item.masterAccountId }}
          </template>
          <template v-else> Global </template>
        </template>
        <template #[`item.categoryIds`]="{ item }">
          <template v-if="item.categoryIds && item.categoryIds.length">
            {{ item.categoryIds.map((id) => category_name(id) || id).join(', ') }}
          </template>
          <template v-else> All </template>
        </template>
        <template #[`item.actions`]>
          <v-icon>more_vert</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <EditPromoCode />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import EditPromoCode from '@/components/promocodes/Edit';
export default {
  name: 'PromoCodes',

  components: { EditPromoCode },

  data: () => {
    return {
      headers: [
        { text: 'Code', value: 'code' },
        { text: 'Type', value: 'productTypeId' },
        { text: 'Value', value: 'value' },
        { text: 'Min', value: 'minimumProductValue' },
        { text: 'Start', value: 'startDate' },
        { text: 'End', value: 'endDate' },
        { text: 'Uses Remaining', value: 'usesRemaining' },
        { text: 'Multiple Use', value: 'multipleUse' },
        { text: '1st Print Only', value: 'firstPrintOnly' },
        { text: 'Master Account', value: 'masterAccountId' },
        { text: 'Categories', value: 'categoryIds', sortable: false },
        { text: '', value: 'actions' }
      ],
      loading: false
    };
  },

  computed: {
    ...mapGetters({
      items: 'promocodes/list',
      master_account_name: 'lookup/master_account_name',
      product_type_name: 'lookup/product_type_name',
      category_name: 'lookup/category_name'
    })
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('promocodes/load')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.PROMO_CODE_EDIT_SHOW, {
        id: item.id
      });
    }
  }
};
</script>
